import { lazy } from 'react';

/**
 * lazyPage — React.lazy with support for named-export pages.
 *
 * Usage:
 *   const Board = lazyPage(() => import(/* webpackChunkName: "m-orders" *\/ './pages/BoardPage'));
 *   // second arg only for a page exported under a name rather than as default:
 *   const Board = lazyPage(() => import(/* webpackChunkName: "m-orders" *\/ './pages/BoardPage'), (m) => m.Board);
 *
 * Manifests use this so page code loads per MODULE chunk on first navigation
 * instead of shipping in the main bundle. The webpackChunkName comment groups
 * every page of a module into one chunk.
 */
export const lazyPage = (loader, pick) =>
    lazy(() => loader().then((m) => ({ default: pick ? pick(m) : m.default })));
